import React, { useState } from 'react';
import { passwordCheckNew, UploadBankStatementSignzy } from '../AdminActionCreator.component';
import Loader from '../../../presentationals/Loader/Loader.component';
import Popup from '../../../presentationals/Popup/Popup.component';
import { ABHICASH_ONLY, CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDFIN_LIKE } from '../../../../layouts/MainTenantconfig';
import { buildTenantPostHeader } from '../../../../utils/apiHeaders';

export default function SignzyBankStatementUpload({ handleSignzyBankStatementPopup, userDetail, customTenantDefaults }) {
    const customHeaderPOSTTenant = CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(ABHICASH_ONLY) ? customTenantDefaults?.sourceAggregatorTenant ?? null : null
    const [selectedFile, setSelectedFile] = useState(null);
    const [password, setPassword] = useState('');
    const [isPasswordRequired, setIsPasswordRequired] = useState(false);
    const [loaderState, setLoaderState] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successPopup, setSuccessPopup] = useState({ show: false, msg: '' });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSelectedFile(file);
        setIsPasswordRequired(false);
        setPassword('');
        setErrorMsg('');

        const ext = file.name.split('.').pop().toLowerCase();
        if (ext === 'pdf') {
            setLoaderState(true);
            passwordCheckNew(file, (callBack) => {
                setLoaderState(false);
                if (callBack === 'success') {
                    setIsPasswordRequired(true);
                }
            }).catch((err) => {
                setLoaderState(false);
                console.error('Password check error:', err);
            });
        }
    };

    const handleSubmit = () => {
        if (!selectedFile) {
            setErrorMsg('Please select a bank statement file to upload.');
            return;
        }

        if (isPasswordRequired && !password) {
            setErrorMsg('Please enter the password for this PDF file.');
            return;
        }

        setLoaderState(true);
        setErrorMsg('');

        const userId = userDetail?.userId;

        UploadBankStatementSignzy(selectedFile, password, userId, customHeaderPOSTTenant, (callBack) => {
            console.log("callBack",callBack)
            setLoaderState(false);
            if (callBack?.status == 'success') {
                setSuccessPopup({ show: true, msg: 'Bank Statement Uploaded Successfully!' });
                setTimeout(() => {
                    handleSignzyBankStatementPopup(false);
                }, 2000);
            } else {
                setErrorMsg('Upload failed. Please check your credentials or try again.');
            }
        }).catch((err) => {
            setLoaderState(false);
            setErrorMsg('An error occurred during upload.');
        });
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    return (
        <>
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slideUp {
                    from { transform: translateY(30px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .signzy-popup-backdrop {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.4);
                    backdrop-filter: blur(8px);
                    z-index: 1040;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: fadeIn 0.3s ease-out;
                }
                .signzy-popup-card {
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(10px);
                    border-radius: 20px;
                    border: 1px solid rgba(255, 255, 255, 0.6);
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                    padding: 30px;
                    max-width: 520px;
                    width: 90%;
                    position: relative;
                    animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                    color: #1e293b;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }
                .signzy-close-btn {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    border: none;
                    background: #f1f5f9;
                    color: #64748b;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .signzy-close-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                    transform: rotate(90deg);
                }
                .signzy-title {
                    font-size: 22px;
                    font-weight: 800;
                    text-align: center;
                    margin-bottom: 25px;
                    background: linear-gradient(135deg, #3b82f6, #4f46e5);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .signzy-user-info {
                    background: #f8fafc;
                    border-radius: 12px;
                    padding: 12px 16px;
                    margin-bottom: 20px;
                    border: 1px solid #f1f5f9;
                }
                .signzy-user-info-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 4px;
                    font-size: 13px;
                }
                .signzy-user-info-row:last-child {
                    margin-bottom: 0;
                }
                .signzy-user-label {
                    color: #64748b;
                    font-weight: 500;
                }
                .signzy-user-val {
                    color: #0f172a;
                    font-weight: 600;
                }
                .signzy-dropzone {
                    border: 2px dashed #cbd5e1;
                    border-radius: 14px;
                    padding: 30px 20px;
                    text-align: center;
                    cursor: pointer;
                    background: #f8fafc;
                    transition: all 0.25s ease;
                    position: relative;
                }
                .signzy-dropzone:hover {
                    border-color: #3b82f6;
                    background: #f0f7ff;
                    transform: translateY(-2px);
                }
                .signzy-file-input {
                    position: absolute;
                    inset: 0;
                    opacity: 0;
                    cursor: pointer;
                }
                .signzy-upload-icon {
                    font-size: 36px;
                    color: #3b82f6;
                    margin-bottom: 12px;
                }
                .signzy-upload-text {
                    font-size: 15px;
                    font-weight: 600;
                    color: #334155;
                    margin-bottom: 4px;
                }
                .signzy-upload-subtext {
                    font-size: 12px;
                    color: #64748b;
                }
                .signzy-selected-file {
                    display: flex;
                    align-items: center;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 12px;
                    padding: 12px 16px;
                    margin-top: 15px;
                }
                .signzy-file-details {
                    flex: 1;
                    margin-left: 12px;
                    text-align: left;
                }
                .signzy-file-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #166534;
                    word-break: break-all;
                }
                .signzy-file-size {
                    font-size: 12px;
                    color: #15803d;
                }
                .signzy-pwd-section {
                    margin-top: 20px;
                    text-align: left;
                }
                .signzy-pwd-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #475569;
                    margin-bottom: 6px;
                    display: block;
                }
                .signzy-pwd-input {
                    width: 100%;
                    padding: 10px 14px;
                    border-radius: 8px;
                    border: 1.5px solid #cbd5e1;
                    font-size: 14px;
                    outline: none;
                    transition: all 0.2s ease;
                }
                .signzy-pwd-input:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
                }
                .signzy-error-box {
                    background: #fef2f2;
                    border: 1px solid #fecaca;
                    border-radius: 8px;
                    padding: 10px 14px;
                    color: #991b1b;
                    font-size: 13px;
                    margin-top: 15px;
                    text-align: left;
                    font-weight: 500;
                }
                .signzy-success-box {
                    background: #fef2f2;
                    border: 1px solid #d3feca;
                    border-radius: 8px;
                    padding: 10px 14px;
                    color: #23991b;
                    font-size: 13px;
                    margin-top: 15px;
                    text-align: left;
                    font-weight: 500;
                }
                .signzy-submit-btn {
                    width: 100%;
                    background: linear-gradient(135deg, #3b82f6, #4f46e5);
                    color: white;
                    font-size: 15px;
                    font-weight: 600;
                    border: none;
                    border-radius: 10px;
                    padding: 12px 20px;
                    margin-top: 25px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
                }
                .signzy-submit-btn:hover:not(:disabled) {
                    box-shadow: 0 8px 16px rgba(59, 130, 246, 0.35);
                    transform: translateY(-1px);
                    filter: brightness(1.05);
                }
                .signzy-submit-btn:active:not(:disabled) {
                    transform: translateY(1px);
                }
                .signzy-submit-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                    box-shadow: none;
                }
            `}</style>


            <div className="signzy-popup-backdrop" onClick={() => handleSignzyBankStatementPopup(false)}>
                <div className="signzy-popup-card" onClick={(e) => e.stopPropagation()}>
                    <button className="signzy-close-btn" onClick={() => handleSignzyBankStatementPopup(false)}>
                        &times;
                    </button>
            {loaderState && <Loader />}
            {/* {successPopup.show && <Popup popupStatus={successPopup.msg} closePopup={() => setSuccessPopup({ show: false, msg: '' })} />} */}
                    <div className="signzy-title">Upload Bank Statement via Signzy</div>

                    <div className="signzy-user-info">
                        <div className="signzy-user-info-row">
                            <span className="signzy-user-label">Applicant Name</span>
                            <span className="signzy-user-val">{userDetail?.firstName} {userDetail?.lastName}</span>
                        </div>
                        <div className="signzy-user-info-row">
                            <span className="signzy-user-label">Loan Application ID</span>
                            <span className="signzy-user-val">{userDetail?.applicationId || 'N/A'}</span>
                        </div>
                        <div className="signzy-user-info-row">
                            <span className="signzy-user-label">User ID</span>
                            <span className="signzy-user-val">{userDetail?.userId}</span>
                        </div>
                    </div>

                    <div className="signzy-dropzone">
                        <input
                            type="file"
                            className="signzy-file-input"
                            accept="application/pdf, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={handleFileChange}
                        />
                        <div className="signzy-upload-icon">
                            <i className="fa fa-cloud-upload"></i>
                        </div>
                        <div className="signzy-upload-text">Select Bank Statement File</div>
                        <div className="signzy-upload-subtext">Supported formats: PDF, CSV, Excel</div>
                    </div>

                    {selectedFile && (
                        <div className="signzy-selected-file">
                            <div style={{ fontSize: '24px', color: '#166534' }}>
                                <i className="fa fa-file-text-o"></i>
                            </div>
                            <div className="signzy-file-details">
                                <div className="signzy-file-name">{selectedFile.name}</div>
                                <div className="signzy-file-size">{formatBytes(selectedFile.size)}</div>
                            </div>
                            <div style={{ color: '#166534', fontSize: '18px' }}>
                                <i className="fa fa-check-circle"></i>
                            </div>
                        </div>
                    )}

                    {isPasswordRequired && (
                        <div className="signzy-pwd-section">
                            <label className="signzy-pwd-label">PDF Statement Password</label>
                            <input
                                type="password"
                                className="signzy-pwd-input"
                                placeholder="Enter PDF password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrorMsg('');
                                }}
                            />
                        </div>
                    )}

                    {successPopup?.show && (
                        <div className="signzy-success-box">
                            <i className="fa fa-tick" style={{ marginRight: '8px' }}></i>
                            {successPopup.msg}
                        </div>
                    )}
                    {errorMsg && (
                        <div className="signzy-error-box">
                            <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                            {errorMsg}
                        </div>
                    )}

                    <button
                        className="signzy-submit-btn"
                        onClick={handleSubmit}
                        disabled={!selectedFile || (isPasswordRequired && !password)}
                    >
                        SUBMIT STATEMENT
                    </button>
                </div>
            </div>
        </>
    );
}
